import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { InstagramEmbed, FacebookEmbed, TikTokEmbed, LinkedInEmbed, BlueskyEmbed } from 'react-social-media-embed';

import './style.scss';

const ParagraphSocialMediaEmbed = ({ id, entity }) => {
  const socialLinks = entity.getIn(['field_social_links']);

  return (
    <Container id={id} className="ParagraphSocialMediaEmbed">
      <div className="row ParagraphSocialMediaEmbed__items">
        {socialLinks.map((socialLink) => {
          let SocialComponent;
          const socialUrl = socialLink.get('value');

          if (socialUrl.includes('instagram.')) SocialComponent = InstagramEmbed;
          if (socialUrl.includes('facebook.')) SocialComponent = FacebookEmbed;
          if (socialUrl.includes('tiktok.')) SocialComponent = TikTokEmbed;
          if (socialUrl.includes('linkedin.')) SocialComponent = LinkedInEmbed;
          if (socialUrl.includes('bluesky.')) SocialComponent = BlueskyEmbed;

          return (
            <div key={socialUrl} className="col-12 col-md-6 col-lg-4">
              <div className="ParagraphSocialMediaEmbed__items__item">
                <SocialComponent url={socialUrl} />
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default ParagraphSocialMediaEmbed;
